import { render, staticRenderFns } from "./tree-transfer.vue?vue&type=template&id=4064ffca&"
import script from "./tree-transfer.vue?vue&type=script&lang=js&"
export * from "./tree-transfer.vue?vue&type=script&lang=js&"
import style0 from "./tree-transfer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports